﻿import ActionsMenu from '../../../../components/ActionsMenu';

export function ValueProperties({
    selectedValue,
    isEditingValueName,
    editValueNameText,
    setEditValueNameText,
    setIsEditingValueName,
    isSavingValueName,
    onRenameValueSubmit,
    onDeleteValue,
    emptyMessage = 'Select a value in the tree view to manage its details.'
}) {
    if (!selectedValue) {
        return (
            <div style={{ flex: 1.2, borderLeft: '1px solid var(--border)', paddingLeft: '1.5rem', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '1rem', minWidth: 0 }}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', border: '1px dashed var(--border)', borderRadius: 'var(--radius)', padding: '1.5rem', textAlign: 'center', color: 'var(--text-secondary)', fontSize: '0.75rem', gap: '0.35rem', height: '150px' }}>
                    <i className="fa-solid fa-hand-pointer" style={{ opacity: 0.3, fontSize: '1.25rem' }}></i>
                    <span>{emptyMessage}</span>
                </div>
            </div>
        );
    }

    return (
        <div style={{ flex: 1.2, borderLeft: '1px solid var(--border)', paddingLeft: '1.5rem', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '1rem', minWidth: 0 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid var(--border)', paddingBottom: '0.75rem', marginBottom: '0.25rem' }}>
                    {isEditingValueName ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <input 
                                className="input-field" 
                                value={editValueNameText} 
                                onChange={e => setEditValueNameText(e.target.value)} 
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onRenameValueSubmit(e);
                                    }
                                }}
                                style={{ fontSize: '0.9rem', fontWeight: 'bold', padding: '0.25rem 0.5rem', margin: 0, width: '180px', background: 'var(--bg-primary)' }}
                                autoFocus
                                required
                            />
                            <button type="button" disabled={isSavingValueName} onClick={onRenameValueSubmit} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--success)', padding: '0.25rem' }} title="Save Value Name">
                                <i className="fa-solid fa-check" style={{ fontSize: '1rem' }}></i>
                            </button>
                            <button type="button" onClick={() => { setIsEditingValueName(false); setEditValueNameText(selectedValue.value); }} style={{ background: 'transparent', border: 'none', cursor: 'pointer', color: 'var(--error)', padding: '0.25rem' }} title="Cancel">
                                <i className="fa-solid fa-xmark" style={{ fontSize: '1rem' }}></i>
                            </button>
                        </div>
                    ) : (
                        <h5 style={{ margin: 0, fontSize: '1rem', color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: '0.35rem', minWidth: 0 }}>
                            <i className="fa-solid fa-cube" style={{ color: 'var(--accent)' }}></i>
                            {selectedValue.value}
                        </h5>
                    )}
                    {!isEditingValueName && (
                        <ActionsMenu
                            label="Value actions"
                            items={[
                                {
                                    label: 'Rename Value',
                                    icon: 'fa-solid fa-pen',
                                    onSelect: () => {
                                        setEditValueNameText(selectedValue.value);
                                        setIsEditingValueName(true);
                                    }
                                },
                                {
                                    label: 'Delete Value',
                                    icon: 'fa-solid fa-trash-can',
                                    danger: true,
                                    onSelect: onDeleteValue
                                }
                            ]}
                        />
                    )}
                </div>
                
                <p style={{ margin: 0, fontSize: '0.7rem', color: 'var(--text-secondary)' }}>
                    Display name, image, and template fields for this value are edited in Release Master.
                </p>
            </div>
        </div>
    );
}
